// utils > String

export function padZero(str: string | number, minLength: number = 2) {
	return padString(str, '0', minLength)
}

export function padString(
	str: string | number,
	padWith: string = '',
	minLength: number,
	padFromIx: number = 0
) {
	const typeOfStr = typeof str
	if (typeOfStr !== 'number' && typeOfStr !== 'string') {
		console.warn('Must provide a string or number to pad')
		return str
	}

	let finalString = typeof str === 'number' ? str.toString() : str
	const difference = minLength - finalString.length

	if (difference > 0) {
		const padFrom =
			padFromIx >= finalString.length
				? finalString.length - 1
				: padFromIx < 0
					? 0
					: padFromIx
		let add = ''

		for (let i = 0; i < difference; i++) {
			add += padWith
		}

		finalString =
			finalString.slice(0, padFrom) + add + finalString.slice(padFrom)
	}

	return finalString
}
